import { Link } from "react-router-dom";
import FooterLogo from "../assets/img/white.svg"

const missions = [
    { name: 'Nos recommandations', href: '/strategie-retraite/' },
    { name: 'Bilans retraite', href: '/bilan-retraite/' },
    { name: 'Articulation chômage / retraite', href: '/articulation-chomage-retraite/' },
    { name: 'Des solutions d\'optimisation', href: '/solutions-optimisation/' },
    { name: 'Etudes comparatives expatriation', href: '/retour-expatriation/' },
    { name: 'Des conférences spécifiques', href: '/nos-conferences/' },
    { name: 'Liquidations de retraite', href: '/liquidations-retraite/' },
]

export default function Footer() {
    return (
        <>
        <section className="bg-oranges flex">
            <img src={FooterLogo} className="w-1/2 sm:w-1/3 lg:w-1/6 m-auto" />
        </section>
        
        <footer id="contact" aria-labelledby="footer-heading" className="bg-white">        
            <div className="mx-auto max-w-7xl px-6 pb-8 pt-10 sm:pt-10 lg:px-8 lg:pt-24">
                <div className="grid md:grid-cols-3 gap-8">                    
                        <div className="col-span-1">
                            <div>
                                <h3 className="text-xl py-6 font-semibold leading-6 text-gray-900 border-b-2 border-gray-500">Nos missions</h3>
                                <ul role="list" className="mt-6 space-y-1">
                                    {missions.map((item) => (
                                        <li key={item.name}>
                                            <Link to={item.href} className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>                            
                        </div>
                        <div className="col-span-1">
                            <div className="mt-10 md:mt-0">
                                <h3 className="text-xl py-6 font-semibold leading-6 text-gray-900 border-b-2 border-gray-500">Contact</h3>
                                <p className="text-sm leading-6 font-bold text-gray-600 mt-6 hover:text-gray-900">
                                    Sylviane Aguirre
                                </p>
                                <p className="pt-4 text-sm leading-6 text-gray-600 hover:text-gray-900">
                                    07 87 10 09 05
                                </p>
                                <p className="pt-1 text-sm leading-6 font-bold text-gray-600 hover:text-gray-900">
                                    sylviane.aguirre@wanadoo.fr
                                </p>
                                <p className="pt-1 text-sm leading-6 font-bold text-gray-600 hover:text-gray-900">
                                    s.aguirre@expertise-benefits.com
                                </p>
                            </div>
                        </div>
                        <div className="col-span-1">
                            <div>
                                <h3 className="text-xl py-6 font-semibold leading-6 text-gray-900 border-b-2 border-gray-500">Adresse</h3>
                                <p className="text-sm leading-6 font-bold text-gray-600 mt-6 hover:text-gray-900">
                                    Siège social
                                </p>
                                <p className="pt-4 text-sm leading-6 text-gray-600 hover:text-gray-900">
                                    27 rue la Résistance
                                </p>
                                <p className="pt-1 text-sm leading-6 font-bold text-gray-600 hover:text-gray-900">
                                    92220 Bagneux - France
                                </p>
                            </div>                
                        </div>
                    </div>           
                
                
                <div className="mt-10 border-t border-gray-900/10 pt-8 sm:mt-20 md:flex md:items-center md:justify-between lg:mt-24">            
                    <p className="mt-8 text-xs leading-5 text-gray-500 md:order-1 md:mt-0">
                        &copy; 2024 Experts&Benefits. Tous droits réservés.
                    </p>
                </div>
            </div>
        </footer>
        </>
)
}
